<template>
  <v-dialog v-model="receiveDialog" class="the-app-dialogs" persistent max-width="900px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing: 2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add Receive') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-layout row xs12>
              <v-flex xs4 pa-2 ma-2 green lighten-3 v-show="showBalanceDetail">
                <p class="subheading font-weight-regular mb-0">
                  {{ $t('Total Debit') }}:
                  <strong>{{ account.total_debit | currency }} {{ systemCurrency }}</strong>
                </p>
              </v-flex>

              <v-flex xs4 pa-2 ma-2 red lighten-3 @click="showBalanceDetail = !showBalanceDetail">
                <p class="subheading font-weight-regular mb-0">
                  {{ $t('Total Balance') }}:
                  <strong>{{ account.total_balance | currency }} {{ systemCurrency }}</strong>
                </p>
              </v-flex>

              <v-flex xs4 pa-2 ma-2 yellow lighten-3 v-show="showBalanceDetail">
                <p class="subheading font-weight-regular mb-0">
                  {{ $t('Total Credit') }}:
                  <strong>{{ account.total_credit | currency }} {{ systemCurrency }}</strong>
                </p>
              </v-flex>
            </v-layout>

            <v-flex xs12 pt-4 text-xs-center>
              <h3>{{ account.customer_name }}</h3>
            </v-flex>
            <v-flex xs12 pb-4 pt-2 mr-5 ml-5>
              <v-divider />
            </v-flex>

            <v-flex xs6 pa-2>
              <v-autocomplete
                v-model="form.receive_type"
                :label="`${$t('Receive Type')} *`"
                hide-details
                :items="paymentTypes"
                box
                data-vv-name="Payment Type"
                background-color="white"
                :error="errors.has('Payment Type')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="form.date"
                  :label="`${$t('Payment Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="receive_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('receive_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="dateMenu = false" v-model="form.date" />
              </v-menu>
            </v-flex>

            <v-flex xs6 pa-2 v-if="form.receive_type === 'Remittance'">
              <v-autocomplete
                v-model="form.remittance_office_id_fk"
                :label="`${$t('Remittance Office')} *`"
                hide-details
                :items="remittances"
                box
                data-vv-name="Remittance Office"
                background-color="white"
                :error="errors.has('Remittance Office')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs6 pa-2 v-if="form.receive_type === 'Remittance'">
              <v-text-field
                v-model.number="form.remittance_commission"
                :label="`${$t('Remittance Commission')} (${systemCurrency}) *`"
                name="remittance_commission"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                data-vv-delay="1000"
                :error="errors.has('remittance_commission')"
                v-validate="'required|decimal|min_value:0'"
              />
            </v-flex>

            <v-flex xs5 class="pa-2">
              <v-text-field
                id="single-receive-focus-me"
                v-model.number="form.amount"
                :label="`${$t('Amount')} (${systemCurrency}) *`"
                name="amount"
                box
                hide-details
                background-color="white"
                append-icon="fa-hand-holding-usd"
                @click:append="isMultiCurrency = !isMultiCurrency"
                :readonly="isMultiCurrency"
                autocomplete="off"
                :error="errors.has('amount')"
                v-validate="'required|decimal|min_value:0'"
              />
            </v-flex>

            <v-flex xs2 class="pa-2">
              <v-text-field
                v-model.number="form.discount"
                :label="`${$t('Discount')} (${systemCurrency})`"
                name="discount"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                v-validate="'decimal|min_value:0'"
              />
            </v-flex>

            <v-flex xs5 class="pa-2">
              <v-text-field
                :value="netAmount"
                :label="`${$t('Net Amount')} (${systemCurrency})`"
                name="net_amount"
                box
                hide-details
                readonly
                background-color="white"
                autocomplete="off"
                v-validate="'decimal|min_value:0'"
              />
            </v-flex>

            <v-flex xs3 class="pa-2">
              <v-text-field
                v-if="isMultiCurrency"
                v-model="form.amount_main"
                :label="`${$t('Amount')} (${systemCurrency}) *`"
                box
                hide-details
                background-color="white"
                name="amount_main"
                :error="errors.has('amount_main')"
                v-validate="'required|decimal:3|min_value:0'"
                @input="amountCalculation()"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex xs3 pr-2 pl-2 pt-2>
              <v-text-field
                v-if="isMultiCurrency"
                v-model="form.amount_secondary"
                :label="`${$t('Amount')} (${systemCurrency === 'USD' ? $t('IQD') : $t('USD')}) *`"
                box
                :hint="`${$t('Dollar Rate')} : ${dollarRate}`"
                persistent-hint
                background-color="white"
                name="amount_secondary"
                :error="errors.has('amount_secondary')"
                v-validate="'required|decimal:3|min_value:0'"
                @input="amountCalculation()"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-textarea
                v-model="form.note"
                :label="$t('Note')"
                name="payment_note"
                box
                hide-details
                height="80"
                background-color="white"
              />
            </v-flex>

            <v-flex
              xs12
              v-if="viewInfo.receive_detail && viewInfo.receive_detail.length > 0"
              style="margin-top: 40px; margin-bottom:20px"
            >
              <v-layout row wrap justify-center mb-2>
                <v-flex xs3 ml-5>
                  <h3>{{ $t('Receive Details') }}</h3>
                </v-flex>
                <v-flex xs10 ml-5 mr-5>
                  <v-divider />
                </v-flex>
              </v-layout>
              <v-layout row wrap class="view-table-header">
                <v-flex xs1 pa-2>#</v-flex>
                <v-flex xs5 pa-2>{{ $t('Date') }}</v-flex>
                <v-flex xs3 pa-2>{{ `${$t('Amount')} (${systemCurrency})` }}</v-flex>
                <v-flex xs3 pa-2>{{
                  `${$t('Amount')} (${systemCurrency === $t('USD') ? $t('IQD') : $t('USD')})`
                }}</v-flex>
              </v-layout>

              <template v-if="viewInfo.receive_detail && viewInfo.receive_detail.length > 0">
                <v-layout row wrap v-for="(row, index) in viewInfo.receive_detail" :key="index">
                  <v-flex class="view-table-row" xs1>
                    <p class="view-table-content">{{ index + 1 }}</p>
                  </v-flex>
                  <v-flex class="view-table-row" xs5>
                    <p class="view-table-content">
                      {{ row.receive_date }}
                    </p>
                  </v-flex>
                  <v-flex class="view-table-row" xs3>
                    <p class="view-table-content">
                      {{ row.amount_main | currency }}
                    </p>
                  </v-flex>
                  <v-flex class="view-table-row" xs3>
                    <p class="view-table-content">
                      {{ row.amount_secondary | currency }}
                    </p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6 pr-4 class="view-table-row">
                    <strong class="view-table-content">{{ $t('Total Received') }}</strong>
                  </v-flex>
                  <v-flex class="view-table-row" xs6>
                    <p class="view-table-content">
                      <strong>{{ viewInfo.received | currency }}</strong>
                    </p>
                  </v-flex>
                </v-layout>
              </template>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'payment-component',

  props: {
    receiveDialog: { type: Boolean, required: true },
    account: { type: Object, required: true },
    statement: { type: Object, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      dateMenu: false,
      form: {
        date: '',
        receive_type: '',
        remittance_office_id_fk: null,
        remittance_commission: null,
        amount: 0,
        discount: 0,
        amount_main: 0,
        amount_secondary: 0,
        note: ''
      },
      isMultiCurrency: false,
      showBalanceDetail: false
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'receivableStatements/getStatementInfo',
      dollarRate: 'dollarRates/getLastDollarPrice',
      paymentTypes: 'accountPayable/getPaymentTypes',
      remittances: 'remittances/getFullRemittanceOfficesList'
    }),
    netAmount() {
      const netAmount = this.form.amount - this.form.discount
      return isNaN(netAmount) ? 0 : netAmount
    }
  },

  watch: {
    receiveDialog: {
      immediate: false,
      handler() {
        if (this.receiveDialog) {
          this.addEscKeyListener()
          this.$validator.pause()
          for (let key in this.form) {
            this.form[`${key}`] = null
          }
          this.form.date = this.$moment()
            .format()
            .substr(0, 10)
          this.form.receive_type = 'Cash'
          this.form.amount = (this.statement.amount - this.viewInfo.received).toFixed(2)
          this.form.discount = 0
          this.form.amount_main = 0
          this.form.amount_secondary = 0
          this.isMultiCurrency = false

          this.$nextTick(() => {
            this.$validator.resume()
            // default veutify autofocus only one time works so we have to handled in this way.
            // document.getElementById('single-receive-focus-me').focus()
          })
        }
      }
    },
    isMultiCurrency() {
      if (this.receiveDialog) {
        this.$validator.pause()
        if (this.isMultiCurrency) {
          this.form.amount_secondary =
            this.systemCurrency === 'USD'
              ? Number(this.form.amount) * this.dollarRate
              : Number(this.form.amount) / this.dollarRate
          this.form.amount_main = 0
        } else {
          this.form.amount_main = 0
          this.form.amount_secondary = 0
        }

        this.$nextTick(() => {
          this.$validator.resume()
        })
      }
    }
  },

  methods: {
    ...mapActions({
      addPayment: 'receivableStatements/statementPayment'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.receiveDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    amountCalculation() {
      const exchangeSecondary =
        this.systemCurrency === 'USD'
          ? Number(this.form.amount_secondary) / this.dollarRate
          : Number(this.form.amount_secondary) * this.dollarRate
      this.form.amount = (Number(this.form.amount_main) + exchangeSecondary).toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('is_multi_currency', this.isMultiCurrency ? '1' : '0')
            formData.append('dollar_rate', this.dollarRate)
            formData.append('account_receivable_id_fk', this.account.account_receivable_id)
            formData.append('receivable_statement_id', this.statement.receivable_statement_id)
            formData.append('cash_remittance_bank', this.form.receive_type)
            formData.append('remittance_office_id_fk', this.form.remittance_office_id_fk || '')

            // for (let pair of formData.entries()) {
            //   console.warn(`${pair[0]}: ${pair[1]}`)
            // }

            this.addPayment(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                this.$emit('hidemodal')
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
